import { evaluate } from 'mathjs/number';

const CALCULATION_CHARACTERS = /^[\d\s+\-*/().]+$/;

const calculate = (calculation) => {
  try {
    return evaluate(calculation);
  } catch {
    return null;
  }
};

export const calculateExpression = (value, formatResult) => {
  const calculation = String(value).trim();

  if (!CALCULATION_CHARACTERS.test(calculation)) {
    return value;
  }
  const result = calculate(calculation);

  return Number.isFinite(result) ? formatResult(result) : value;
};
